export default "__VITE_ASSET__xF04bBTu__"